import React, { Component } from 'react'
import SpecialKeysReact from 'special-keys-react'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'
import history from 'utils/appHistory'
import { t } from 'translation'

import CompositionsList from 'components/CompositionsList/CompositionsList'
import CompositionsListSongItem from 'components/CompositionsList/CompositionsListSongItem'
import CompositionsListGenreItem from 'components/CompositionsList/CompositionsListGenreItem'
import ControlList from 'components/ControlList/ControlList'
import Logo from 'components/Logo/Logo'
import AlarmModal from 'components/AlarmModal/AlarmModal'
import SettingsModal from 'components/SettingsModal/SettingsModal'
import Spinner from 'components/ui/Spinner/Spinner'
import InviteModal from 'components/InviteModal/InviteModal'

import {
  resetPainLevelsAndSessionId,
  resetSongInfo,
  setSongId,
  fetchAllMusic,
  downloadSongs,
  toggleDownloadInBackground,
  setDownloadPromise,
  fetchAllLocalMusic,
  setPainLevelBefore,
} from 'store/actions'

import { SLEEP, AWAKENING } from 'utils/constants'

// Load images for all genres
import AllGenresImg from 'assets/genres/genre.png'

class SongSelectPage extends Component {
  constructor() {
    super()

    this.state = {
      selectedGenreId: 'all',
      selectedGenreName: null,
      areSettingsOpen: false,
      isAlarmOpen: window.cordova
        ? !!history.location.query?.alarm
        : !!history.location.state?.alarm,
      selectedSongs: [],
      selectedLocalSongs: [],
      isInviteOpen: false,
      isLoadingSongs: true,
      initialLoadDone: false,
      initialLoadLocalDone: false,
      currentGenre: -1,
      currentSong: -1,
    }

    SpecialKeysReact.config({
      left: () => {
        this.backBtn.click()
      },
      right: () => {
        if (this.state.currentSong !== -1) {
          this.songsRef.current[
            this.state.currentSong + 1 > this.songsRef.current.length - 1
              ? 0
              : this.state.currentSong + 1
          ].focus()
          this.setState({
            currentSong:
              this.state.currentSong + 1 > this.songsRef.current.length - 1
                ? 0
                : this.state.currentSong + 1,
          })
        }

        if (this.state.currentGenre !== -1) {
          this.genresRef.current[
            this.state.currentGenre + 1 > this.genresRef.current.length - 1
              ? 0
              : this.state.currentGenre + 1
          ].focus()
          this.setState({
            currentGenre:
              this.state.currentGenre + 1 > this.genresRef.current.length - 1
                ? 0
                : this.state.currentGenre + 1,
          })
        }
      },
      up: () => {
        if (this.state.currentGenre === -1) {
          this.setState({ currentSong: -1 })
          this.genresRef.current[0].focus()
          this.setState({ currentGenre: 0 })
        }
      },
      down: () => {
        if (this.state.currentSong === -1) {
          this.setState({ currentGenre: -1 })
          this.songsRef.current[0].focus()
          this.setState({ currentSong: 0 })
        }
      },
      backspace: () => {},
      enter: () => {
        if (this.state.currentGenre !== -1)
          this.genresRef.current[this.state.currentGenre].click()
        if (this.state.currentSong !== -1)
          this.songsRef.current[this.state.currentSong].click()
      },
    })

    this.mainElement = React.createRef()
    this.genresRef = {
      current: [],
    }
    this.songsRef = {
      current: [],
    }
  }

  backBtn = null

  attachBackBtnRef = (btn) => (this.backBtn = btn)

  componentDidMount() {
    if (window?.cordova) this.loadLocalSongs('all')

    if (this.props.indicationType)
      this.setState({
        selectedGenreName: t(`indication.${this.props.indicationType.toUpperCase()}`),
      })

    // Initiate async task only if we will not redirect away from this page.
    if (
      this.props.indicationType &&
      !this.props.isFetchingGenres &&
      !this.props.isFetchingSongs
    )
      this.props.fetchAllMusic()

    const songsInit = JSON.parse(localStorage.getItem('songsInitialized'))

    if (
      window?.cordova &&
      window.device?.platform === 'Android' &&
      !this.props.isPro &&
      this.props.downloadedSongs.length > 0 &&
      !songsInit
    )
      history.push('/update-songs-mobile')

    if (
      window?.cordova &&
      window.device?.platform === 'Android' &&
      this.props.isPro &&
      this.props.downloadedSongs.length > 0 &&
      songsInit
    )
      history.push('/update-songs-mobile')

    this.mainElement.current.focus()
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.isAlarmOpen || this.state.areSettingsOpen)
      document.body.classList.add('modal_open')
    else document.body.classList.remove('modal_open')

    if (
      window?.cordova &&
      this.props.isFetchingSongsFromRemote &&
      ((this.props.allLocalSongs.length && !this.state.initialLoadLocalDone) ||
        prevProps.allLocalSongs.length !== this.props.allLocalSongs.length)
    )
      this.loadLocalSongs('all')

    if (
      !this.props.isFetchingGenres &&
      !this.props.isFetchingSongs &&
      ((this.props.allSongs.length && !this.state.initialLoadDone) ||
        prevProps.allSongs.length !== this.props.allSongs.length ||
        prevProps.allSongs.some(
          ({ songId }, i) => songId !== this.props.allSongs[i].songId
        ))
    )
      this.loadGenreSongs('all')

    this.genresRef.current = this.genresRef.current.filter((btn) => btn)

    if (prevState.selectedGenreId != this.state.selectedGenreId)
      this.songsRef.current = this.songsRef.current.filter((btn) => btn)

    // if (!this.state.initialLoadDone)
    //   this.mainElement.current.focus()
  }

  componentWillUnmount() {
    this.isUnmounting = true
    document.body.classList.remove('modal_open')
  }

  loadGenreSongs = (selectedGenreId) => {
    // Load music songs corresponding to the desired genre
    const selectedSongs = this.props.allSongs
      // Keep only songs that match current genre, or if all genres, keep all
      .filter(
        ({ genreId, genreIdTwo, genreIdThree }) =>
          selectedGenreId === 'all' ||
          genreId === selectedGenreId ||
          genreIdTwo === selectedGenreId ||
          genreIdThree === selectedGenreId
      )

      // Attach click handler for selecting song
      .map((song) => ({
        ...song,
        setSongHandler: () => {
          // Save selected song to store
          this.props.setSongId(song.songId)

          // Reset existing pain 'before' rating that may have been set
          // in previous session which was never completed
          this.props.resetPainLevelsAndSessionId()

          // Reset existing songInfo that was loaded in previous session
          this.props.resetSongInfo()

          const platform = window.device?.platform
          // TODO: In case version refers to API level, check what version refers to exactly
          const isAndroid11 =
            window.device?.version.startsWith('11') ||
            window.device?.version.startsWith('30')

          if (
            window.cordova &&
            platform === 'Android' &&
            isAndroid11 &&
            this.props.isOnline
          )
            this.startDownloadingSong(song.songId)

          // Go directly to player if SLEEP mode
          if (
            this.props.indicationType === SLEEP ||
            this.props.indicationType === AWAKENING
          )
            history.replace('/player')
          else {
            this.props.setPainLevelBefore(1)
            history.replace('/player')
          }
        },
      }))

    // const selectedGenreName =
    //   // Check if user selected 'All' genres
    //   selectedGenreId === 'all'
    //     ? t('genre.ALL')
    //     : (this.props.allGenresMap[selectedGenreId] || {}).genreName || ''

    this.setState({
      selectedSongs,
      selectedGenreId,
      isLoadingSongs: false,
      initialLoadDone: true,
    })
  }

  loadLocalSongs = (selectedGenreId) => {
    // Load music songs corresponding to the desired genre
    const selectedLocalSongs = this.props.allLocalSongs
      // Keep only songs that match current genre, or if all genres, keep all
      .filter(
        ({ genreId, genreIdTwo, genreIdThree }) =>
          selectedGenreId === 'all' ||
          genreId === selectedGenreId ||
          genreIdTwo === selectedGenreId ||
          genreIdThree === selectedGenreId
      )

      // Attach click handler for selecting song
      .map((song) => ({
        ...song,
        setSongHandler: () => {
          // Save selected song to store
          this.props.setSongId(song.songId)

          // Reset existing pain 'before' rating that may have been set
          // in previous session which was never completed
          this.props.resetPainLevelsAndSessionId()

          // Reset existing songInfo that was loaded in previous session
          this.props.resetSongInfo()

          // Go directly to player if SLEEP mode
          if (
            this.props.indicationType === SLEEP ||
            this.props.indicationType === AWAKENING
          )
            history.replace('/player')
          else {
            this.props.setPainLevelBefore(1)
            history.replace('/player')
          }
        },
      }))

    // const selectedGenreName =
    //   // Check if user selected 'All' genres
    //   selectedGenreId === 'all'
    //     ? t('genre.ALL')
    //     : (this.props.allLocalGenresMap[selectedGenreId] || {}).genreName || ''

    this.setState({
      selectedLocalSongs,
      selectedGenreId,
      initialLoadLocalDone: true,
    })
  }

  clickGenreHandler = (genreId) => {
    !this.props.isFetchingSongsFromRemote
      ? this.loadGenreSongs(genreId)
      : this.loadLocalSongs(genreId)
  }

  toggleAlarmHandler = () => {
    this.setState((prevState) => ({
      isAlarmOpen: !prevState.isAlarmOpen,
    }))
  }

  toggleSettingsHandler = () => {
    this.setState((prevState) => ({
      areSettingsOpen: !prevState.areSettingsOpen,
    }))
  }

  toggleInviteHandler = () => {
    this.setState((prevState) => ({
      isInviteOpen: !prevState.isInviteOpen,
    }))
  }

  startDownloadingSong = (songId) => {
    if (
      this.props.indicationType === SLEEP ||
      this.props.isDownloading ||
      this.props.downloadedSongs.includes(songId)
    )
      return

    this.props.setDownloadPromise(
      this.props.downloadSongs([songId], this.props.allSongsMap)
    )
    this.props.toggleDownloadInBackground()
  }

  render() {
    const genresListEntries = Object.values(
      this.props.isFetchingSongsFromRemote && window?.cordova
        ? this.props.allLocalGenresMap
        : this.props.allGenresMap
    ).map(({ genreName, genreId, genreImageUrl }, index) => (
      <CompositionsListGenreItem
        key={genreId}
        image={genreImageUrl}
        title={genreName}
        selected={this.state.selectedGenreId === genreId}
        genreId={genreId}
        clickGenreHandler={this.clickGenreHandler}
        index={index + 1}
        genresRef={this.genresRef}
      />
    ))

    const songsListEntries = this.state.selectedSongs.map(
      ({ setSongHandler, imageUrl, artist, title, songId, newUntil }, index) => (
        <CompositionsListSongItem
          key={songId}
          image={imageUrl}
          title={title}
          subtitle={artist}
          clickHandler={setSongHandler}
          newUntil={newUntil}
          isDownloaded={this.props.downloadedSongs.includes(songId)}
          index={index}
          songsRef={this.songsRef}
        />
      )
    )

    const songsListLocalEntries = this.state.selectedLocalSongs.map(
      ({ setSongHandler, imageUrl, artist, title, songId, newUntil }, index) => (
        <CompositionsListSongItem
          key={songId}
          image={imageUrl}
          title={title}
          subtitle={artist}
          clickHandler={setSongHandler}
          newUntil={newUntil}
          isDownloaded={true}
          index={index}
          songsRef={this.songsRef}
        />
      )
    )

    const closedAlarmCreationInJSession =
      this.props.indicationType === AWAKENING &&
      history.location.state &&
      history.location.state.alarm &&
      !this.state.isAlarmOpen

    return (
      <div ref={this.mainElement} {...SpecialKeysReact.events} tabIndex="1">
        {!this.state.isInviteOpen && (
          <>
            <section className="section index_mod alarm_mod">
              {/* If session type is not set, go to set it first */}
              {(!this.props.indicationType || closedAlarmCreationInJSession) &&
              history.location.pathname !== '/indication-select' ? (
                <Redirect to="/indication-select" />
              ) : null}

              <ControlList
                toggleAlarmHandler={this.toggleAlarmHandler}
                toggleSettingsHandler={this.toggleSettingsHandler}
                toggleInviteHandler={this.toggleInviteHandler}
                attachBackBtnRef={this.attachBackBtnRef}
              />

              <CompositionsList
                listTitle={t('genre.CHOOSE_SESSION')}
                mainModClass="genres_mod"
              >
                {!window?.cordova &&
                  (this.props.isFetchingGenres ? (
                    <div className="composition_list_spinner">
                      <Spinner />
                    </div>
                  ) : (
                    genresListEntries
                  ))}

                {window?.cordova &&
                  (genresListEntries.length > 0 ? (
                    genresListEntries
                  ) : (
                    <div className="composition_list_spinner">
                      <Spinner />
                    </div>
                  ))}
              </CompositionsList>

              <CompositionsList
                listTitle={t('genre.DISCOVER_TREATMENTS')}
                mainModClass="songs_mod"
                listSubtitle={this.state.selectedGenreName}
                listLimitClass="limit_mod"
              >
                {!window?.cordova &&
                  (this.props.error ? (
                    <div className="section_subtitle offset_mod v1_mod songs_msg_mod">
                      {t('genre.ERROR')}
                    </div>
                  ) : this.props.isFetchingGenres ||
                    this.props.isFetchingSongs ||
                    this.state.isLoadingSongs ? (
                    <div className="composition_list_spinner">
                      <Spinner />
                    </div>
                  ) : (
                    songsListEntries
                  ))}

                {window?.cordova &&
                  (this.props.error && !this.props.allLocalSongs.length ? (
                    <div className="section_subtitle offset_mod v1_mod songs_msg_mod">
                      {t('genre.ERROR')}
                    </div>
                  ) : this.props.isFetchingSongsFromRemote ||
                    this.props.isFetchingSongs ||
                    (this.props.allLocalSongs.length > 0 &&
                      this.props.allSongs.length === 0) ? (
                    songsListLocalEntries
                  ) : !this.props.isFetchingSongs && this.props.allSongs.length > 0 ? (
                    songsListEntries
                  ) : (
                    <div className="composition_list_spinner">
                      <Spinner />
                    </div>
                  ))}

                {/* {this.props.error ? (
                  <div className="section_subtitle offset_mod v1_mod songs_msg_mod">
                    {t('genre.ERROR')}
                  </div>
                ) : this.props.isFetchingGenres ||
                  this.props.isFetchingSongs ||
                  this.state.isLoadingSongs ? (
                  <div className="composition_list_spinner">
                    <Spinner />
                  </div>
                ) : window.cordova &&
                  !this.props.allSongs.length &&
                  !this.props.isFetchingSongs &&
                  this.state.initialLoadDone ? (
                  <div className="section_subtitle offset_mod v1_mod songs_msg_mod">
                    {t('genre.NO_SESSIONS_OFFLINE')}
                  </div>
                ) : !this.props.allSongs.length &&
                  !this.props.isFetchingSongs &&
                  this.state.initialLoadDone ? (
                  <div className="section_subtitle offset_mod v1_mod songs_msg_mod">
                    {t('genre.NO_SESSIONS')}
                  </div>
                ) : (
                  songsListEntries
                )} */}
              </CompositionsList>

              <div className="player_bottom_wrap">
                <div className="player_bottom v2_mod">
                  <Logo />
                </div>
              </div>
            </section>
            <SettingsModal
              toggleSettingsHandler={this.toggleSettingsHandler}
              areSettingsOpen={this.state.areSettingsOpen}
            />
            <AlarmModal
              isAlarmModalOpen={this.state.isAlarmOpen}
              toggleAlarmHandler={this.toggleAlarmHandler}
            />
          </>
        )}
        {this.props.isPro && (
          <InviteModal
            isInviteModalOpen={this.state.isInviteOpen}
            toggleInviteHandler={this.toggleInviteHandler}
          />
        )}
      </div>
    )
  }
}

const mapStateToProps = ({
  auth: { isPro, isOnline },
  player: {
    indicationType,
    allSongs,
    allSongsMap,
    allLocalSongs,
    allLocalSongsMap,
    isFetchingGenres,
    isFetchingSongs,
    isFetchingSongsFromRemote,
    allGenresMap,
    allLocalGenresMap,
    error,
  },
  download: { downloadedSongs, isDownloading },
}) => ({
  allSongsMap,
  allGenresMap,
  allSongs,
  allLocalSongs,
  allLocalSongsMap,
  allLocalGenresMap,
  error,
  indicationType,
  isFetchingGenres,
  isFetchingSongs,
  isFetchingSongsFromRemote,
  isPro,
  isOnline,
  downloadedSongs,
  isDownloading,
})

const willMapDispatchToProps = {
  resetPainLevelsAndSessionId,
  resetSongInfo,
  setSongId,
  fetchAllMusic,
  fetchAllLocalMusic,
  downloadSongs,
  toggleDownloadInBackground,
  setDownloadPromise,
  setPainLevelBefore,
}

export default connect(mapStateToProps, willMapDispatchToProps)(SongSelectPage)
